import { Box, BoxProps, useStyleConfig } from "@chakra-ui/react";
import React from "react";

export const H3: React.FC<BoxProps> = ({ children, ...props }) => {
  const styles = useStyleConfig("h3");

  return (
    <Box as="h3" __css={styles} {...props}>
      {children}
    </Box>
  );
};
